import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ButtonExperiment } from '@/components/ButtonExperiment';
import { ExtendedLink } from '@/components/ExtendedLink';

const DEPOP_CLOUDFRONT_HOST = process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST;

export function MakeOfferModalSent() {
  const t = useTranslations('offers');
  const pathname = usePathname();
  const isOffersPage = pathname === '/messages/offers';

  return (
    <div className={styles.content}>
      <img
        src={`${DEPOP_CLOUDFRONT_HOST}/web/assets/make-offer-spin-sticker.gif`}
        height={188}
        width={188}
        alt=""
      />
      <Body variant="sm-regular" className={styles.successText}>
        {t('OfferSuccess')}
      </Body>
      {!isOffersPage && (
        <ExtendedLink
          href="/messages/offers/"
          passHref
          className={styles.messagesCta}
        >
          <ButtonExperiment as="span" fullWidth>
            {t('SeeOffers')}
          </ButtonExperiment>
        </ExtendedLink>
      )}
    </div>
  );
}
